import { NavLink, Outlet } from "react-router-dom";
import { Mail, Send, FileText, History, LayoutDashboard, Settings, Layers, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const navItems = [
  { path: "/", icon: LayoutDashboard, label: "Dashboard" },
  { path: "/bulk-send", icon: Send, label: "Bulk Send" },
  { path: "/templates", icon: Layers, label: "Templates" },
  { path: "/logs", icon: History, label: "Email Logs" },
  { path: "/smtp-settings", icon: Settings, label: "SMTP Settings" },
];

export const Layout = () => {
  const { user, logout } = useAuth();

  return (
    <div className="flex min-h-screen bg-[#0a0a0a]">
      {/* Sidebar */}
      <aside 
        className="w-64 bg-[#0d0d0d] text-white fixed left-0 top-0 h-screen overflow-y-auto z-50 border-r border-[#1a1a1a]"
        data-testid="sidebar"
      >
        {/* Logo */}
        <div className="p-4 border-b border-[#1a1a1a]">
          <div className="flex items-center justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_mail-dispatch-18/artifacts/bs8dk0ju_IMG_5169.PNG" 
              alt="Delta AI Academy"
              className="h-20 object-contain"
            />
          </div>
        </div>

        {/* User Info */}
        {user && (
          <div className="px-4 py-3 border-b border-[#1a1a1a]">
            <p className="text-sm font-medium text-white truncate">{user.name || user.email}</p>
            <p className="text-xs text-slate-500 truncate">{user.email}</p>
          </div>
        )}

        {/* Navigation */}
        <nav className="p-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200 ${
                  isActive
                    ? "bg-cyan-500/10 text-cyan-400 border-l-2 border-cyan-400"
                    : "text-slate-400 hover:text-white hover:bg-white/5"
                }`
              }
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <item.icon className="w-5 h-5 stroke-[1.5px]" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Footer with Logout */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-[#1a1a1a]">
          <button
            onClick={logout}
            className="flex items-center gap-3 w-full px-4 py-3 text-sm font-medium text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-all"
            data-testid="btn-logout"
          >
            <LogOut className="w-5 h-5 stroke-[1.5px]" />
            Sign Out
          </button>
          <p className="text-xs text-slate-600 text-center mt-3">
            © 2026 Delta AI Academy
          </p>
        </div>
      </aside>

      {/* Main Content */}
      <main className="ml-64 flex-1 min-h-screen bg-[#0a0a0a]">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
